import { render, staticRenderFns } from "./CatalogueComponent.vue?vue&type=template&id=dab409a0&scoped=true&"
import script from "./CatalogueComponent.vue?vue&type=script&lang=js&"
export * from "./CatalogueComponent.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueComponent.vue?vue&type=style&index=0&id=dab409a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab409a0",
  null
  
)

export default component.exports